const ABSOLUTE_LINK = /^https?:\/\//

export const isAbsoluteUrl = url => ABSOLUTE_LINK.test(url)


// WEBPACK FOOTER //
// ./src/utils/url.js